import React from "react";

const BillDeskPay = () => {
  return <h1>payment response page</h1>;
};
export default BillDeskPay;
